import store from '../store';

export function useStore() {
  return store;
}
